import { render, staticRenderFns } from "./atacSeqDetails.vue?vue&type=template&id=2e5ae6e8&"
import script from "./atacSeqDetails.vue?vue&type=script&lang=js&"
export * from "./atacSeqDetails.vue?vue&type=script&lang=js&"
import style0 from "./atacSeqDetails.vue?vue&type=style&index=0&id=2e5ae6e8&prod&scpoed=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports